import { Hidden, makeStyles, TableCell, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { calculatedHourFields, hourFields } from '../../config/staticValues';
import { sumProperty } from '../../util/helperFunctions';
import TimecardDatasheetDay from './TimecardDatasheetDay';
import Visible from '../../components/Visible';

const styles = makeStyles((theme) => ({
  headerRow: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  totalRow: {
    backgroundColor: theme.palette.background.paper,
  },
  dayColumn: {
    minWidth: '240px',
    [theme.breakpoints.down('xs')]: {
      minWidth: 'inherit',
    },
  },
}));
const TimecardDatasheetWeek = ({ days, saveUpdate, disabled }) => {
  const classes = styles();
  const workHours = sumProperty(days, 'workHours');
  const vacationHours = sumProperty(days, 'vacationHours');
  const sickHours = sumProperty(days, 'sickHours');
  const holidayHours = sumProperty(days, 'holidayHours');
  const clockedHours = sumProperty(days, 'clockedHours');
  const serviceHours = sumProperty(days, 'serviceHours');
  const bonusHours = sumProperty(days, 'bonusHours');
  const bonusHoursOver38 = sumProperty(days, 'bonusHoursOver38');
  const hours = {
    workHours,
    vacationHours,
    sickHours,
    holidayHours,
    clockedHours,
    serviceHours,
    bonusHours,
    bonusHoursOver38,
  };
  const HeaderCell = ({ label, padding }) => (
    <TableCell
      component="th"
      align="right"
      style={{ paddingRight: '' + padding === '0' ? '0' : padding || 31 }}
    >
      <Typography className={classes.headerRow}>{label}</Typography>
    </TableCell>
  );
  return (
    <>
      <TableRow>
        <TableCell component="th" scope="row" align="right">
          <Typography className={classes.headerRow}>Day</Typography>
        </TableCell>
        <Visible mdUp>
          {hourFields.map((field, index) => (
            <HeaderCell key={index} label={field.label} />
          ))}
        </Visible>
        <Visible mdUp>
          {calculatedHourFields.map((field, index) => (
            <HeaderCell key={index} label={field.label} padding={6} />
          ))}
        </Visible>
        <Visible only="sm">
          {hourFields.map((field, index) => (
            <HeaderCell key={index} label={field.shortLabel} />
          ))}
        </Visible>
        <Visible only="xs">
          {hourFields.map((field, index) => (
            <HeaderCell key={index} label={field.shortLabel} padding={17} />
          ))}
        </Visible>
      </TableRow>
      {days.map((row) => (
        <TimecardDatasheetDay
          row={row}
          disabled={disabled}
          key={row.id}
          classes={classes}
          saveUpdate={saveUpdate}
        />
      ))}
      <TableRow className={classes.totalRow}>
        <TableCell component="th" scope="row" align="right">
          <Typography className={classes.headerRow}>Totals</Typography>
        </TableCell>
        <Visible smUp>
          {hourFields.map((field, index) => (
            <TableCell key={index} align="right" style={{ paddingRight: 31 }}>
              <Typography>{Number.parseFloat(hours[field.id]).toFixed(2)}</Typography>
            </TableCell>
          ))}
        </Visible>
        <Visible xsDown>
          {hourFields.map((field, index) => (
            <TableCell key={index} align="right" style={{ paddingRight: 17 }}>
              <Typography>{Number.parseFloat(hours[field.id]).toFixed(2)}</Typography>
            </TableCell>
          ))}
        </Visible>
        <Visible mdUp>
          <TableCell align="right">
            <Typography>{Number.parseFloat(hours['clockedHours']).toFixed(2)}</Typography>
          </TableCell>
          <TableCell align="right">
            <Typography>{Number.parseFloat(hours['serviceHours']).toFixed(2)}</Typography>
          </TableCell>
          <TableCell align="right">
            <Typography>
              {(
                Number.parseFloat(hours['bonusHours']) +
                Number.parseFloat(hours['bonusHoursOver38'])
              ).toFixed(2)}
            </Typography>
          </TableCell>
        </Visible>
      </TableRow>
    </>
  );
};

export default TimecardDatasheetWeek;
